import { createRequestTypes } from 'common/websocket-redux';

export const GET_USER_HISTORY = createRequestTypes('service/GET_USER_HISTORY');
